import { SubscriptionsEffects } from './subscriptions.effect';

export * from './subscriptions.effect';

export const effects = [SubscriptionsEffects];
